'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReminderBtn = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

var _reactMinimalPieChart = require('react-minimal-pie-chart');

var _reactMinimalPieChart2 = _interopRequireDefault(_reactMinimalPieChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TravellerName = function TravellerName(_ref) {
    var travellerId = _ref.travellerId,
        firstName = _ref.firstName,
        lastName = _ref.lastName,
        isComplete = _ref.isComplete;
    return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('traveller-name', { 'is-complete': isComplete }) },
        _react2.default.createElement(
            _reactRouter.Link,
            { to: '/' + travellerId, tabIndex: '0' },
            firstName,
            ' ',
            lastName
        )
    );
};

var CompletedTag = function CompletedTag(_ref2) {
    var isComplete = _ref2.isComplete;
    return isComplete ? _react2.default.createElement(
        'span',
        { className: 'completed_by' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'passengerListItem.completed',
            defaultMessage: 'Completed'
        })
    ) : null;
};

var RequirementsCounter = function RequirementsCounter(_ref3) {
    var isComplete = _ref3.isComplete,
        requirementStepsComplete = _ref3.requirementStepsComplete,
        requirementStepsTotal = _ref3.requirementStepsTotal;

    var data = [{
        value: requirementStepsComplete,
        color: '#62D8C2'
    }, {
        value: requirementStepsTotal - requirementStepsComplete,
        color: '#e0e0e0'
    }];
    if (isComplete) {
        return _react2.default.createElement('span', { className: 'check', 'aria-hidden': 'false' });
    } else {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactMinimalPieChart2.default, {
                data: data,
                startAngle: 90,
                animate: true
            })
        );
    }
};

var ReminderBtn = function ReminderBtn(props) {
    return _react2.default.createElement(
        'button',
        {
            className: 'button',
            onClick: function onClick() {
                props.updateUI('reminderModalIsVisible', !props.ui.reminderModalIsVisible);
                if (props.emailAddress) {
                    props.updateUI('reminderModalData', {
                        customerId: props.customerId,
                        checkinUrl: props.checkinUrl,
                        recipientEmail: props.emailAddress
                    });
                } else {
                    props.updateUI('reminderModalData', {
                        customerId: props.customerId,
                        checkinUrl: props.checkinUrl,
                        recipientEmail: null
                    });
                }
            }
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'passengerListItem.reminder', defaultMessage: 'Send Reminder' })
    );
};
exports.ReminderBtn = ReminderBtn = (0, _reduxUi2.default)()((0, _pacomo.pacomoTransformer)(ReminderBtn));
exports.ReminderBtn = ReminderBtn;


var PassengerListItem = function PassengerListItem(props) {
    var showReminder = !props.isUserPassenger && !props.isComplete;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'requirements-completed' },
            _react2.default.createElement(RequirementsCounter, {
                requirementStepsComplete: props.requirementStepsComplete,
                requirementStepsTotal: props.requirementSteps,
                isComplete: props.isComplete
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'traveller-name' },
            props.isUserPassenger && _react2.default.createElement(_components2.IconPassenger, { 'aria-hidden': 'false' }),
            _react2.default.createElement(TravellerName, {
                travellerId: props.passengerId,
                firstName: props.firstName,
                lastName: props.lastName,
                isComplete: props.isComplete
            }),
            _react2.default.createElement(
                'span',
                null,
                '(',
                props.requirementStepsComplete,
                '/',
                props.requirementSteps,
                ')'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('reminder-btn', { 'show-reminder': showReminder }) },
            showReminder && _react2.default.createElement(ReminderBtn, {
                customerId: props.passengerId,
                checkinUrl: props.checkinUrl,
                emailAddress: props.emailAddress
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'link' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: '/' + props.passengerId, tabIndex: '0', 'aria-label': 'Passenger details' },
                _react2.default.createElement(_components2.IconRight, { 'aria-hidden': 'false' })
            )
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(PassengerListItem);


//////////////////
// WEBPACK FOOTER
// ./app/components/PassengerList/PassengerListItem.js
// module id = 630
// module chunks = 0